require('./components/googleplace');
require('./components/file-autoupload');
require('./components/file-upload');

/* Init 3rd party components and button */

(function() {

    // select 2

    $('.select2').each(function() {
        let $this = $(this),
            params = $this.data();
        $this.select2(params);
    });
 

    // labels
    $('.cradio--other input:text').on("click",function (e) {
        e.preventDefault();
        e.stopPropagation()
    });
    $('.cradio input:radio').on("change" ,function(e){

        $(".cradio input[name="+$(this).attr("name")+"]").parent().find("input:text").attr("disabled",true);
        $(this).parent().find("input[type=text]").attr("disabled",false)

    });
   
    //available mark
    $(".cform-input.status").find("input").on('focus',function(){
        $(this).closest(".cform-input").removeClass("status")
    });
     
    // menu
/*
    $(document).on('click', function(e){
        if(!$(e.target).parent().hasClass('Header-brand')){
            $(".Header-mainmenu").removeClass("active")
        }
    });
*/
    $(document).on("click", function(e){
        if($(e.target).closest(".Header-mainmenu").length == 0 &&
            $(".Header-mainmenu").hasClass("active") &&
            $(e.target).closest(".btn-close").length == 0 &&
            $(e.target).closest(".cbtn-toggle").length == 0 
        ){
            $('.Header-mainmenu').toggleClass('active');
            $('body').toggleClass('overflow-hidden');
        }

    });
    $('.cbtn-toggle,.btn-close').on("click",function(){
        $(".Header-mainmenu").toggleClass("active")
        $('body').toggleClass('overflow-hidden');
    });


    $('.clist-input-check').on("change",function(){

        if($(this).hasAttribute('readonly')) return;
       
        let container = $(this).closest('.clist-check').find(".cprogress");

        let bar = $(container).find("span[role=progressbar]");
        let val = parseInt($(container).find("small").text().replace("%",""));
        let cant = $(this).attr("rel");
        if($(this).is(":checked")){
            $(bar).removeClass("w-"+val);
            $(bar).addClass("w-"+ (parseInt(val)+ parseInt(cant) ));
            $(container).find("small").text( (parseInt(val)+ parseInt(cant) )+"%")

        }else{
            $(bar).removeClass("w-"+val);
            $(bar).addClass("w-"+ (parseInt(val) - parseInt(cant)));
            $(container).find("small").text( (parseInt(val)- parseInt(cant) )+"%")
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    let $carrousel = $('.carousel');
    $carrousel.carousel({
         interval: 2000
    });
    $carrousel.find('.prev').click(function(){
        var carousel = $(this).attr("rel");
        $(carousel).carousel('prev')

    });

    $carrousel.find('.next').click(function(){
        var carousel = $(this).attr("rel");
        $(carousel).carousel('next')
    });

    $('.ccarousel-box').owlCarousel({
        nav: true,
        margin: 30,
        dots: false,
        responsive : {
            // breakpoint from 0 up
            0 : {
                items : 1,
            },
            // breakpoint from 480 up
            480 : {
                items : 1,
            },
            // breakpoint from 768 up
            768 : {
                items :2,
            }
        }
    });

     $('.ccarousel-testimonials .ccarousel-container').owlCarousel({
        nav: true,
        dots: false,
        items : 1
     });

    $('.ccarousel-gallery').owlCarousel({
        nav: true,
        dots: false,
        items : 1,
        lazyLoad: true
    });

    $('.ccarousel-gallery-container').owlCarousel({
        nav: true,
        dots: true,
        items : 1, 
        lazyLoad: true
    });

    let memberCarousel = $('.ccarousel-member');

    memberCarousel.owlCarousel({
        nav: false,
        dots: true,
        items : 1,
        touchDrag  : false,
        mouseDrag  : false,
    });

    let myProfileCarousel = $('.my-profile-carousel');
    let myProfileCarouselStep = $('.my-profile-carousel').data('carousel-step');
    let startPosition = myProfileCarouselStep - 1;
    if(myProfileCarousel.hasClass('my-profile-upgrade')){
        startPosition = 0;
    }
    myProfileCarousel.owlCarousel({
        nav: false,
        dots: false,
        items : 1,
        touchDrag  : false,
        mouseDrag  : false,
        startPosition: startPosition
    });

    $(".cmodal-gallery-thumb").click(function(){

        var modal = $(this).data('target').split("#")[0];
        var slide = $(this).data('target').split("#")[1] || 0;
        var carousel = $("#"+modal).find(".ccarousel-gallery").owlCarousel();

        carousel.trigger('to.owl.carousel',[slide, 300]);
        $("#"+modal).modal('show');

    });


    $('.cmodal button.close[data-dismiss="modal"]').click(function () {
        let videoIframe = $(this).siblings('.modal-body').find('iframe');
        if (videoIframe) {
            let videoIframeSrc = videoIframe.attr('src');
            videoIframe.attr('src', videoIframeSrc);
        }
    });

    $('body').on('click', '.cmodal' , function (e) {
        if(!$(e.target).closest('.cmodal iframe').length && !$(e.target).is('.cmodal iframe')) {
            let videoIframe = $('.modal-body').find('iframe');
            if (videoIframe) {
                let videoIframeSrc = videoIframe.attr('src');
                videoIframe.attr('src', videoIframeSrc);
            }
        }
    });

    $( document ).ready(function() {
        headerOnScroll();
    });

    function headerOnScroll() {
        let currentPosition = $(this).scrollTop();


        //on load

        currentPosition = $(this).scrollTop();

        if (currentPosition > 10) {
            $('.pg-navbar').addClass('is-scrolling');
        } else {
            $('.pg-navbar').removeClass('is-scrolling');
        }

        $(window).scroll(function(){

            currentPosition = $(this).scrollTop();

            if (currentPosition > 10) {
                $('.pg-navbar').addClass('is-scrolling');
            } else {
                $('.pg-navbar').removeClass('is-scrolling');
            }
        });
    }

    //
    $('.ccarousel-testimonials .ccarousel-container').owlCarousel({
        nav: true,
        dots: false,
        items : 1
    });

})();

